import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Action, View } from '../../../../../../shared/store/view/types';
import {
  User,
  UserDetailModel,
} from '../../../../../../shared/store/user/type';
import { ViewService } from '../../../../../../shared/store/view/views.service';
import { SubHeaderService } from '../../../../../../shared/store/subheader/subheader.service';
import { UserService } from '../../../../../../shared/store/user/user.service';
import { filterTrue } from '../../../../../../shared/pipe/rxjs/operators';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-custom-actions-flow-user',
  templateUrl: './custom-actions-flow-user.component.html',
  styleUrls: ['./custom-actions-flow-user.component.scss'],
  standalone: false,
})
export class CustomActionsFlowUserComponent implements OnInit {
  view$: Observable<View>;
  user$: Observable<UserDetailModel>;
  userActions$: Observable<Action[]>;

  constructor(
    private readonly viewService: ViewService,
    private readonly subHeaderService: SubHeaderService,
    private readonly userService: UserService,
  ) {
    this.view$ = this.viewService.getViews.value$;
    this.user$ = this.userService.getById.value$;
    this.userActions$ = this.userService.getStatusActions.value$;
  }

  ngOnInit(): void {
    this.user$.pipe(filterTrue(), take(1)).subscribe((user) => {
      this.userService.getStatusActions.call(user.id.toString());
    });
  }

  triggerAction(actionName) {
    this.subHeaderService.setTriggerAction(actionName);
  }
}
